<!--
 * @Author: your name
 * @Date: 2020-11-05 14:18:52
 * @LastEditTime: 2021-03-23 16:07:51
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \xy_project\src\views\Home\Todo.vue
-->
<template>
  <div id='todo'>
    <div id="dialogBg" v-if="isShowMonitor"></div>
    <template v-if="flag==1">
      <el-row class="header">
        <img src="@/assets/img/待办.png" alt="">
        <span v-if="roleType==2">我的提醒</span>
        <span v-if="roleType==3">待办事项</span>
      </el-row>
      <ul class="todoStyle" v-if="roleType==2">
        <li class="liTitle">我的提醒</li>
        <li v-if="toDoData&&toDoData.userMemberNumber!=''&&toDoData.userMemberNumber!=0">
          <el-link style="color: #999;" @click="goToCompany">共{{toDoData.userMemberNumber}}家企业尚未认证完善会员信息</el-link>
        </li>
        <li v-if="toDoData&&toDoData.paymentNumber!=null&&toDoData.paymentNumber!=0">
          <el-link style="color: #999;" @click="goToPay">共{{toDoData.paymentNumber}}家企业会费尚未缴纳</el-link>
        </li>
        <!-- <li v-if="toDoData&&toDoData.applyUserNumber!=''&&toDoData.applyUserNumber!=0">
          <el-link style="color: #999;" @click="goToCont()">共{{toDoData.applyUserNumber}}家企业申请入会</el-link>
        </li> -->
        <li v-if="toDoData&&toDoData.questionNumber!=null&&toDoData.questionNumber!=0">
          <el-link style="color: #999;" @click="goToQues">共{{toDoData.questionNumber}}家企业调查表未填写</el-link>
        </li>
        <!-- <li v-if="toDoData&&toDoData.productNumber!=''&&toDoData.productNumber!=0">
          <el-link style="color: #999;" @click="goToCont()">共{{toDoData.productNumber}}家企业申请发布产品</el-link>
        </li> -->
        <li v-if="monitorData.length>0">
          <el-link style="color: #999;" @click="goToMonitor">您有新的{{monitorData.length}}家公司的监控推送</el-link>
        </li>
        <li v-if="needApply>0||soonApply>0||outApply>0">
          <el-link style="color: #999;" @click="$router.push('/home/adminApplication')">
            <span v-if="needApply>0">需要我审批的{{needApply}}条</span>{{needApply>0&&soonApply>0?",":''}}
            <span v-if="soonApply>0">你有{{soonApply}}个任务即将超时</span>{{outApply>0&&soonApply>0?",":''}}
            <span v-if="outApply>0">你有{{outApply}}个任务已经超时</span>
          </el-link>
        </li>
      </ul>
      <ul class="todoStyle" v-if="roleType==3">
        <li class="liTitle">待办事项</li>
        <div v-for="(item,index) in memberToDo" :key="index" @click="todoInfo(item)">
          <!-- <li v-if="item.todoType==1">
            <el-link style="color: #999;" @click="goToCont()">您尚未完善您的产品，请前往产品管理发布产品</el-link>
          </li> -->
          <li v-if="item.todoType==2">
            <el-link style="color: #999;" >您尚未完善您会员档案，请前往会员信息-会员档案里完善</el-link>
          </li>
          <li v-if="item.todoType==3">
            <el-link style="color: #999;" >您尚未完善您公司信息，请前往会员信息-公司信息里完善</el-link>
          </li>
          <li v-if="item.todoType==4">
            <el-link style="color: #999;" >您{{item.year.replace(/,/g,"、")+'年'}}会费尚未缴纳，请联系协会人员，具体缴纳情况请前往会员信息-会员档案-缴费记录中查看</el-link>
          </li>
          <li v-if="item.todoType==5">
            <!-- <el-link style="color: #999;" @click="goToCont()">您尚未填写xxx年调查表，请前往会员信息-调查表进行填写</el-link> -->
            <el-link style="color: #999;" @click="goToWatch(item)">您尚未填写{{item.year.replace(/,/g,"、")+'年'}}调查表信息，请前往会员信息-调查表进行填写</el-link>
          </li>
        </div>
      </ul>
    </template>
    <template v-if="flag==2">
      <el-row>
        <el-col :xs="23" :sm="23" :md="23" :lg="23" :xl="23">
          我的提醒 > <span class="bread">公司名单</span>
        </el-col>
        <el-col :xs="1" :sm="1" :md="1" :lg="1" :xl="1" class="goBack" @click.native="flag=1">
          <img src="@/assets/img/back.png" alt=""> 返回
        </el-col>
      </el-row>
      <el-divider></el-divider>
      <el-row class="detail" v-if="remindType == 1">以下为申请发布产品的公司名单</el-row>
      <el-row class="detail" v-if="remindType == 2">以下为未完善会员信息的公司名单</el-row>
      <el-row class="detail" v-if="remindType == 4">以下为会费未缴纳的公司名单</el-row>
      <el-row class="detail" v-if="remindType == 5">以下为未完善调查表的公司名单</el-row>
      <el-row class="detail" v-if="remindType == 6">以下为申请入会的公司名单</el-row>
      <el-row class="detail" v-if="remindType == 7">以下为最新的公司监控推送</el-row>
      <el-table :data="remindType==7?monitorData:lossInfoCom" stripe tooltip-effect="dark" style="width: 100%" class="remindTable">

        <template v-if="remindType == 7">
          <el-table-column label="公司名" prop="companyname" key="888">
            <template slot-scope="scope">
              <el-link @click="deleteData(scope.row)">{{scope.row.companyname}}</el-link>
            </template>
          </el-table-column>
          <!-- <el-table-column label="警告时间" prop="waringdate">
          </el-table-column> -->
        </template>
        <template v-else>
          
          <el-table-column label="公司名" prop="memberUnitName" v-if="remindType == 4">
            <template slot-scope="scope">
              <el-link @click="goToComDetail(scope.row)">{{scope.row.memberUnitName}}</el-link>
            </template>
          </el-table-column>
          <el-table-column label="公司名" prop="companyName" v-else>
            <template slot-scope="scope">
              <el-link @click="goToComDetail(scope.row)">{{scope.row.companyName}}</el-link>
            </template>
          </el-table-column>

          <!-- <el-table-column v-if="remindType == 4" label="欠费年份" prop="year">
            <template slot-scope="scope">
              {{scope.row.year==null?'/':scope.row.year}}
            </template>
          </el-table-column> -->
          <el-table-column v-if="remindType == 1" label="申请产品名" prop="">
          </el-table-column>
          <el-table-column v-if="remindType == 1" label="操作">
            <template slot-scope="scope">
              <el-link>去审批</el-link>
            </template>
          </el-table-column>
          <el-table-column v-if="remindType == 6" label="操作">
            <template slot-scope="scope">
              <el-link>去审批</el-link>
            </template>
          </el-table-column>
        </template>
      </el-table>
      <el-pagination v-if="remindType!= 7" @current-change="currentChange" :current-page.sync="comParams.pageNumber" :page-size="comParams.pageSize" background layout="total, prev, pager, next" :total="pageTotal">
      </el-pagination>
    </template>
    <MonitorDialog ref="monitorDialog" />
  </div>
</template>
<script>
import MonitorDialog from '@/views/Home/common/MonitorDialog.vue'
import { findTodoDetail } from '@/api/index'
export default {
  props: ['needApply', 'soonApply', 'outApply'],
  data() {
    return {
      name: "todo",
      roleType: sessionStorage.getItem('roleType'),
      flag: 1,
      toDoData: JSON.parse(sessionStorage.getItem('toToData')),
      memberToDo: JSON.parse(sessionStorage.getItem('memberToDo')),
      toDoList: [],
      lossInfoCom: [],// 公司信息未完善
      pageTotal: 0,
      comParams: {
        pageNumber: 1,
        pageSize: 10,
        todoType: 1,
      },
      remindType: 0,
      monitorData: JSON.parse(localStorage.getItem('monitorData')),
      // nowTime: "",  //记录所有数据已读的时间
      isShowMonitor: false,
      adminTableData: JSON.parse(sessionStorage.getItem('adminTableData')),
      timer: null,
    }
  },
  created() {
    this.init()
  },
  // destroyed() {
  //   clearTimeout(this.timer)
  // },
  methods: {
    init() {
      if (this.$route.query.type == 1) {
        this.flag = 2
        this.remindType = 1
        this.getComInfo(1)
      } else if (this.$route.query.type == 2) {
        this.flag = 2
        this.remindType = 2
        this.getComInfo(2)
      } else if (this.$route.query.type == 4) {
        // 会费尚未缴纳

        this.flag = 2
        this.remindType = 4
        // this.getComInfo(4)
        this.getFeeNopaid()
      } else if (this.$route.query.type == 5) {
        this.flag = 2
        this.remindType = 5
        this.getComInfo(5)
      } else if (this.$route.query.type == 6) {
        this.flag = 2
        this.remindType = 6
        this.getComInfo(6)
      } else if (this.$route.query.type == 7) {
        this.flag = 2
        this.remindType = 7
      }
    },
    goToWatch(text) {
      this.$router.push(`/home/management?type=${text.todoType}&yeart=${text.year}`)
      sessionStorage.setItem('yearT', text.year)
    },
    handleCurrentChange() { },
    goBackRemind() { },
    goToCont() { },
    // 点击待办事项页面
    todoInfo(text) {
      this.$parent.$parent.$parent.lookTodoInfo(text)
    },
    // 会费尚未缴纳--调用会员管理接口
    async getFeeNopaid(){
      try {
        const { data } = await this.$http({
          method: 'post',
          url: 'user/findUserMember',
          data: {
            pageNumber: this.comParams.pageNumber,
            pageSize: this.comParams.pageSize,
            memberUnitName: '',
            memberGrade: '',
            startTimeStr: '',
            endTimeStr: '',
            mainBusiness: '',
            sort: 'desc',
            sortFieldType: 4,
            year: '',
            memberGradeArray: [],
            mainBusinessArray: [],
            paymentStatus: 2,
            memberNo: ''
          }
        })
        if (data.code !== 0) return
        this.lossInfoCom = JSON.parse(JSON.stringify(data.userMemberList))
        this.pageTotal = data.total
      } catch (error) {
        this.$message.error(error.data.msg)
      }




        
    },
    // 获取未完善的公司信息
    async getComInfo(type) {
      this.comParams.todoType = type
      try {
        const { data } = await findTodoDetail(this.comParams)
        if (data.code != 0) return
        // todoType=5 未完善调查表 手动分页
        if(type == 5){
          let cutList = JSON.parse(JSON.stringify(data.todoDetailList))
          this.lossInfoCom = cutList.splice((this.comParams.pageNumber -1)*10,this.comParams.pageNumber*10)
        }else{
          this.lossInfoCom = JSON.parse(JSON.stringify(data.todoDetailList))
        }
        
        this.pageTotal = data.total

      } catch (error) {
        this.$message.error(error.data.msg)
      }
    },
    // 未完善会员信息的公司名单
    goToCompany() {
      this.flag = 2
      this.remindType = 2
      this.getComInfo(2)
    },
    // 会费尚未缴纳
    goToPay() {
      this.flag = 2
      this.comParams.pageNumber = 1
      this.remindType = 4
      // this.getComInfo(4)
      this.getFeeNopaid()
    },
    // 调查表未填写
    goToQues() {
      this.flag = 2
      this.comParams.pageNumber = 1
      this.remindType = 5
      this.getComInfo(5)
    },
    // 最新公司监控推送
    goToMonitor() {
      this.flag = 2
      this.remindType = 7
    },
    // 去往商安信页面
    async deleteData(row) {
      this.isShowMonitor = true;
      this.$refs.monitorDialog.monitorVisible = true
      this.$refs.monitorDialog.companyname = row.companyname
      this.$refs.monitorDialog.companyid = row.companyid
      this.$refs.monitorDialog.id = row.id
    },
    currentChange(page) {
      this.comParams.pageNumber = page
      if (this.remindType == 2) {
        this.getComInfo(2)
      } else if (this.remindType == 4) {
        this.getFeeNopaid()
      } else if (this.remindType == 5) {
        this.getComInfo(5)
      }
    },
    // 跳往公司详情
    goToComDetail(row) {
      if (this.remindType == 4) {
        this.$router.push({
          name: 'AdminManagement',
          params: {
            status: 5,
            id: row.userId,
            name: row.companyName
          }
        })
      } else {
        this.$router.push({
          path: `/home/management`,
          query: {
            id: row.userId,
            comName: row.companyName,
            initiationTime: row.initiationTime,
            memberGrade: row.memberGrade,
            remindType: this.remindType
          }
        })
      }
    },
  },
  components: {
    MonitorDialog
  }
}
</script>
<style lang='less' scoped>
#todo {
  padding: 0 25px;
  .bread {
    color: #0066cc;
  }
  .detail {
    color: #333;
    font-weight: 550;
    margin-bottom: 25px;
  }
  .goBack {
    color: #0066cc;
    cursor: pointer;
  }
  .header {
    font-size: 16px;
    font-weight: 500;
    img {
      vertical-align: middle;
      margin-right: 15px;
    }
  }
  .toDoTable {
    margin-top: 25px;
  }
  .todoStyle {
    width: 100%;
    height: 100%;
    background: #fff;
    margin-top: 25px;
    text-align: center;
    .liTitle {
      color: #909399;
      font-weight: 550;
      font-size: 15px;
    }

    /deep/ li {
      height: 47px;
      line-height: 47px;
      border-bottom: 1px solid #ebeef5;
      cursor: pointer;
      .el-link {
        line-height: 25px;
        span {
          color: #606266;
        }
      }
    }
  }
}
</style>